import { useTranslation } from 'react-i18next';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
// uncomment this when develop https://xceeddev.atlassian.net/browse/XCEED-5031
// import { useDeleteAdmissionPreset } from '../admissions/use-delete-admission-preset';
// import { PRESET_TYPE_BOTTLE_SERVICE } from '@domain/preset';

const unassignBottleServiceFloorplan = async (floorplanId: string, admissionPresetId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/floorplan-presets/${floorplanId}/admissions/${admissionPresetId}`;

  return request({ url, method: RequestMethod.DELETE });
};

export const useUnassignBottleServiceFloorplan = (floorplanId: string) => {
  const { t } = useTranslation();
  const toast = useToast();
  // uncomment this when develop https://xceeddev.atlassian.net/browse/XCEED-5031
  /* const { mutate: deleteOffer } = useDeleteAdmissionPreset({
        floorplanId,
    }); */

  return useGenericMutation(
    [QUERY_KEYS.unassignBottleService],
    async ({ admissionPresetId }: { admissionPresetId: string }) =>
      unassignBottleServiceFloorplan(floorplanId, admissionPresetId),
    {
      // uncomment this when develop https://xceeddev.atlassian.net/browse/XCEED-5031
      onSuccess: (/* data, variables */) => {
        // deleteOffer({ presetId: variables.admissionPresetId, type: PRESET_TYPE_BOTTLE_SERVICE });

        toast.push({
          title: t('offers:unassignOfferSuccessNotificationTitle'),
          text: '',
          type: 'success',
        });
      },
    }
  );
};
